import { IStackStyles, Spinner, Stack } from "@fluentui/react";
import React from "react";

import { DropdownOption } from "../DropdownOption";

interface DropdownOptionsProps {
    options: DropdownOption[];
    isLoading?: boolean;
    optionsPanelStyles: IStackStyles;
    itemStyles: IStackStyles;
    onItemSelected(option?: DropdownOption): void;
}

export const DropdownOptions = ({
    options,
    isLoading,
    optionsPanelStyles,
    itemStyles,
    onItemSelected
}: DropdownOptionsProps): JSX.Element => {
    if (isLoading) {
        return (
            <Stack verticalAlign="center" styles={optionsPanelStyles}>
                <Spinner hidden={false} />
            </Stack>
        );
    }

    return (
        <Stack styles={optionsPanelStyles} data-is-scrollable={true}>
            {options.length ? (
                options.map((option) => (
                    <Stack
                        key={option.key}
                        styles={itemStyles}
                        onClick={() => onItemSelected(option)}
                        data-is-focusable={true}
                        data-title={option.text}
                        data-testkey={option.key}
                        data-testId={`dropdown-option-${option.text}`}
                    >
                        {option.text}
                    </Stack>
                ))
            ) : (
                <Stack styles={itemStyles}>{"No data"}</Stack>
            )}
        </Stack>
    );
};
